<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <FilterActivity v-if="modalShowFilterActivity" @closeModal="closeModal" @submitFilter="submitFilter" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle title="Activity Log" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <div id="table-header" class="mb-5 flex justify-between items-end">
                <div class="mb-5 flex justify-between">
                  <AddButton to_url="#" button_text="Filter" button_class="text-base py-2 font-medium"
                    @click="showModal" />
                </div>
              </div>
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>User</TableHeadCell>
                    <TableHeadCell>Role</TableHeadCell>
                    <TableHeadCell>Permission</TableHeadCell>
                    <TableHeadCell>Method</TableHeadCell>
                    <TableHeadCell>Url</TableHeadCell>
                    <TableHeadCell>Aktivitas</TableHeadCell>
                    <TableHeadCell>Dilakukan Pada</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="filteredActivityLogs?.length == 0">
                    <TableCell colspan="5" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(activity_log, index) in filteredActivityLogs" :key="activity_log.id"
                    :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ getUserById(activity_log.user_id)?.name || "-" }}</TableCell>
                    <TableCell>{{ getRoleById(activity_log.role_id)?.name || "-" }}</TableCell>
                    <TableCell>{{ getPermissionById(activity_log.permission_id)?.name || "-" }}</TableCell>
                    <TableCell>{{ activity_log.method }}</TableCell>
                    <TableCell>{{ activity_log.url }}</TableCell>
                    <TableCell>{{ activity_log.message }}</TableCell>
                    <TableCell>{{ formatTime(activity_log.createdAt) }}</TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
              <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import PaginationButtons from "@/components/PaginationButtons.vue";
import { Button, ConfirmDialog, Toast } from "primevue";
import { mapActions, mapGetters } from "vuex";
import { formatTime } from "@/helpers/formatTime";
import FilterActivity from "./modals/FilterActivity.vue";
import AddButton from "@/components/buttons/AddButton.vue";

export default {
  name: "ActivityLogsView",
  components: {
    IndexView, PageTitle, ViewContainer, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell, PaginationButtons, ConfirmDialog, Button, Toast, FilterActivity, AddButton
  },
  data() {
    return {
      modalShowFilterActivity: false,
      isBlur: false,
      selectedPettyCash: null,
      currentPage: 1,
      totalPages: 1,
    }
  },
  computed: {
    ...mapGetters('activity_logs', ['allActivityLogs']),
    ...mapGetters('permissions', ['allPermissions']),
    ...mapGetters('roles', ['allRoles']),
    ...mapGetters('users', ['allUsers']),
    filteredActivityLogs() {
      return this.allActivityLogs;
    },
  },
  async created() {
    await this.$store.dispatch('activity_logs/fetchActivityLogs');
    await this.$store.dispatch('permissions/fetchPermissions');
    await this.$store.dispatch('roles/fetchRoles');
    await this.$store.dispatch('users/fetchUsers');
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchActivityLogs({ page: newVal });
      },
    }
  },
  methods: {
    ...mapActions('activity_logs', ['fetchActivityLogs']),
    formatTime,
    getUserById(id) {
      return this.allUsers.find(user => user.id == id);
    },
    getRoleById(id) {
      return this.allRoles.find(role => role.id == id);
    },
    getPermissionById(id) {
      return this.allPermissions.find(permission => permission.id == id);
    },
    async fetchActivityLogs(params = {}) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 50;
      try {
        const { pagination } = await this.$store.dispatch('activity_logs/fetchActivityLogs', params);
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    showModal() {
      this.modalShowFilterActivity = true;
      this.isBlur = true;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowFilterActivity = false;
        this.isBlur = false;
      }, 200);
    },
    submitFilter(filter) {
      this.filter = filter;
      let params = {};

      if (this.filter.user_id) {
        params.user_id = this.filter.user_id;
      }

      if (this.filter.role_id) {
        params.role_id = this.filter.role_id;
      }

      if (this.filter.permission_id) {
        params.permission_id = this.filter.permission_id;
      }

      if (this.filter.method) {
        params.method = this.filter.method;
      }
      this.fetchActivityLogs(params);
      this.updateFilter(filter);
    },
    updateFilter(filter) {
      this.filter = filter;
    },
  },
}
</script>